import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { errorMsg, successMsg } from "../Toastify";
import {
  HodSpecificIndentList,
  UpdateHodIndentStatus,
} from "../../Repository/Api";
import moment from "moment";
import CustomModal from "../CustomModal";

const HodIndentspecificsview = () => {
  const { first_name, access_token, department } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getSpecificlist();
  },[]);

  const [specificIndent, setSpecificIndent] = useState({});
  const [createStatus, setCreateStatus] = useState([]);
  const [validation, setValidation] = useState({});
  const [statusAcceptModel, setStatusAcceptModel] = useState(false);
  const [statusRejectModel, setStatusRejectModal] = useState(false);

  const getSpecificlist = async () => {
    const response = await HodSpecificIndentList(id, token);
    if (response && response.statusCode === 200) {
      setSpecificIndent(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  const setData = (e, key) => {
    let TempData = createStatus;
    TempData[key] = e;
    setCreateStatus(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createStatus.hod_comment) {
      validdateData.hod_comment = "Comment is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleApproveSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      id: id,
      hod_status: "approved",
      hod_comment: createStatus.hod_comment,
    };
    if (CheckValidation()) {
      const response = await UpdateHodIndentStatus(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateStatus({});
        e.target.reset();
        setStatusAcceptModel(false);
        window.location.reload();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleRejectSubmit = async (e) => {
    e.preventDefault();
    const Payload = {
      id: id,
      hod_status: "rejected",
      hod_comment: createStatus.hod_comment,
    };
    if (CheckValidation()) {
      const response = await UpdateHodIndentStatus(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateStatus({});
        e.target.reset();
        setStatusRejectModal(false);
        window.location.reload();
      } else {
        errorMsg(response.message);
      }
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Back To Indent List
                </h6>
                <div className="mt-5">
                  <h5 className="labeltitle centertext">
                    Indent Form Specific View
                  </h5>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>1. Indentor Name</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>{specificIndent?.employee_name}</h6>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>2. Department</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>{specificIndent?.department}</h6>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>3. Indent Number</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>
                        {specificIndent?.indent_number
                          ? specificIndent?.indent_number
                          : "NA"}
                      </h6>
                    </div>
                  </div>
                  <div className="row mt-5">
                    <div className="col-lg-4 col-md-5">
                      <h6>4. Indent Raised Date</h6>
                    </div>
                    <div className="col-lg-1 p-0">:</div>
                    <div className="col-lg-5">
                      <h6>
                        {moment(specificIndent?.requested_date).format(
                          "DD-MM-yyyy"
                        )}
                      </h6>
                    </div>
                  </div>
                  {specificIndent?.hod_comment ? (
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>5. HOD Comment</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {specificIndent?.hod_comment
                            ? specificIndent?.hod_comment
                            : "NA"}
                        </h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {specificIndent?.director_comment ? (
                    <div className="row mt-5">
                      <div className="col-lg-4 col-md-5">
                        <h6>6. Director Comment</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>
                          {specificIndent?.director_comment
                            ? specificIndent?.director_comment
                            : "NA"}
                        </h6>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="mt-5">
                    <h5 className="my-5">Product List</h5>
                  </div>
                  <div>
                    <div className="scroll-table">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th scope="col">S.No</th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Applied Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {specificIndent?.product_details?.map(
                            (product, index) => {
                              return (
                                <tr key={product.id}>
                                  <td>{index + 1}</td>
                                  <td className="textformat">
                                    {product?.product_name}
                                  </td>
                                  <td>
                                    {product?.quantity
                                      ? product?.quantity
                                      : "NA"}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {!specificIndent?.hod_comment ? (
                  <div className="row my-5">
                    <div className="col-lg-3 mx-auto my-auto centertext">
                      <div className="row">
                        <div className="col-lg-6">
                          <button
                            className="rejectbutton"
                            onClick={() => {
                              setStatusRejectModal(true);
                            }}
                          >
                            Reject
                          </button>
                        </div>
                        <div className="col-lg-6">
                          <button
                            className="approvebutton"
                            onClick={() => {
                              setStatusAcceptModel(true);
                            }}
                          >
                            Approve
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </section>
        {/*  ApproveModal */}
        <CustomModal
          open={statusAcceptModel}
          onClickOutside={() => {
            setStatusAcceptModel(false);
            setCreateStatus({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleApproveSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Hod Approve Status</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Hod Comment:
                                  </label>
                                  <textarea
                                    type="text"
                                    className="fieldinput"
                                    placeholder="Enter Comment"
                                    defaultValue={createStatus.hod_comment}
                                    onChange={(e) => {
                                      setData(e.target.value, "hod_comment");
                                    }}
                                  />
                                  {validation.hod_comment && (
                                    <p className="validationerror">
                                      {validation.hod_comment}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setStatusAcceptModel(false);
                      setValidation({});
                      setCreateStatus({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 approvebutton">Approve</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>

        {/*  RejectModel */}
        <CustomModal
          open={statusRejectModel}
          onClickOutside={() => {
            setStatusRejectModal(false);
            setCreateStatus({});
            setValidation({});
          }}
        >
          <form onSubmit={(e) => handleRejectSubmit(e)}>
            <div className="modal-content Modal-View m-auto">
              <div className="modalHeader text-center py-2">
                <h5 className="font-bold mt-2">Hod Reject Status</h5>
              </div>
              <div className="modal-body p-0 ">
                <div className="container">
                  <div className="row d-flex align-items-center justify-content-center  mt-0">
                    <div className="container ">
                      <div className="row justify-content-center">
                        <div className="col-lg-8">
                          <div className=" my-5 px-3">
                            <div className="row justify-content-center mt-2">
                              <div className="col-lg-10">
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Hod Comment:
                                  </label>
                                  <textarea
                                    type="text"
                                    className="fieldinput"
                                    placeholder="Enter Comment"
                                    defaultValue={createStatus.hod_comment}
                                    onChange={(e) => {
                                      setData(e.target.value, "hod_comment");
                                    }}
                                  />
                                  {validation.hod_comment && (
                                    <p className="validationerror">
                                      {validation.hod_comment}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0">
                <div className="my-3">
                  <button
                    type="button"
                    className="btn mx-2 modelclosebtn"
                    onClick={() => {
                      setStatusRejectModal(false);
                      setValidation({});
                      setCreateStatus({});
                    }}
                  >
                    Back
                  </button>
                </div>
                <div>
                  <button className="btn mx-2 rejectbutton">Reject</button>
                </div>
              </div>
            </div>
          </form>
        </CustomModal>
      </div>
    </>
  );
};

export default HodIndentspecificsview;
